export function YesNo(value: boolean | null | undefined): 'Yes' | 'No' | null {
	if (value == null) return null;

	return value ? 'Yes' : 'No';
}
